import useSWR, { Key, SWRResponse } from 'swr'

type Query = {
  [key: string]: any
}

interface QueryService {
  <T = any>(key: Key, query?: Query): SWRResponse<T>
}

export const useQueryService: QueryService = (path, query) => {
  // backendが空文字を許さない場合があるのでパラメータを再構築
  const params = query
    ? Object.fromEntries(Object.entries(query).filter(([_, v]) => v != null && v !== ''))
    : undefined

  return useSWR([path, params])
}
